import { Card, Input } from "antd";

import ParkingOccupancyMonitoringTable from "./Table/ParkingOccupancyMonitoringTable";
import styles from "../MasterManagement/index.module.less";

const ParkingOccupancyMonitoring = () => {
  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={styles["head-container"]}>
          <div className={styles["title-container"]}>
            <span>Parking occupancy monitoring</span>
          </div>
          <div className={` ${styles["extra-container"]}`}>
            <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} />
          </div>
        </div>
      }
    >
      <ParkingOccupancyMonitoringTable />
    </Card>
  );
};
export default ParkingOccupancyMonitoring;
